/* tslint:disable */
/* eslint-disable */
/**
 * SPD
 * Opis api SPD
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GetUserInCompanyDto } from './GetUserInCompanyDto';
import {
    GetUserInCompanyDtoFromJSON,
    GetUserInCompanyDtoFromJSONTyped,
    GetUserInCompanyDtoToJSON,
} from './GetUserInCompanyDto';
import type { GetUserInHealthcareFacilityDto } from './GetUserInHealthcareFacilityDto';
import {
    GetUserInHealthcareFacilityDtoFromJSON,
    GetUserInHealthcareFacilityDtoFromJSONTyped,
    GetUserInHealthcareFacilityDtoToJSON,
} from './GetUserInHealthcareFacilityDto';

/**
 * 
 * @export
 * @interface GetUserDto
 */
export interface GetUserDto {
    /**
     * 
     * @type {string}
     * @memberof GetUserDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof GetUserDto
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetUserDto
     */
    email?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetUserDto
     */
    licenseNumber?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetUserDto
     */
    pwz?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetUserDto
     */
    occupationalMedicineDoctorIdentifier?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetUserDto
     */
    uid?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetUserDto
     */
    pin?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof GetUserDto
     */
    admin?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof GetUserDto
     */
    superadmin?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof GetUserDto
     */
    emailWithReferral?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof GetUserDto
     */
    active?: boolean | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof GetUserDto
     */
    roles?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof GetUserDto
     */
    photo?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetUserDto
     */
    description?: string | null;
    /**
     * 
     * @type {Array<GetUserInHealthcareFacilityDto>}
     * @memberof GetUserDto
     */
    usersInHealthcareFacility?: Array<GetUserInHealthcareFacilityDto> | null;
    /**
     * 
     * @type {Array<GetUserInCompanyDto>}
     * @memberof GetUserDto
     */
    companiesInUser?: Array<GetUserInCompanyDto> | null;
    /**
     * Whether the user has a P1 certificate uploaded
     * @type {boolean}
     * @memberof GetUserDto
     */
    hasCertificate?: boolean;
    /**
     * Whether the user signs P1 XML documents client-side with Szafir instead of the server-stored certificate
     * @type {boolean}
     * @memberof GetUserDto
     */
    signP1WithSzafir?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof GetUserDto
     */
    twoFactorEnabled?: boolean | null;
    /**
     * 
     * @type {Date}
     * @memberof GetUserDto
     */
    lastExamAt?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof GetUserDto
     */
    lastTfaActivityAt?: Date | null;
}

/**
 * Check if a given object implements the GetUserDto interface.
 */
export function instanceOfGetUserDto(value: object): value is GetUserDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    return true;
}

export function GetUserDtoFromJSON(json: any): GetUserDto {
    return GetUserDtoFromJSONTyped(json, false);
}

export function GetUserDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetUserDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'] == null ? undefined : json['name'],
        'email': json['email'] == null ? undefined : json['email'],
        'licenseNumber': json['licenseNumber'] == null ? undefined : json['licenseNumber'],
        'pwz': json['pwz'] == null ? undefined : json['pwz'],
        'occupationalMedicineDoctorIdentifier': json['occupationalMedicineDoctorIdentifier'] == null ? undefined : json['occupationalMedicineDoctorIdentifier'],
        'uid': json['uid'] == null ? undefined : json['uid'],
        'pin': json['pin'] == null ? undefined : json['pin'],
        'admin': json['admin'] == null ? undefined : json['admin'],
        'superadmin': json['superadmin'] == null ? undefined : json['superadmin'],
        'emailWithReferral': json['emailWithReferral'] == null ? undefined : json['emailWithReferral'],
        'active': json['active'] == null ? undefined : json['active'],
        'roles': json['roles'] == null ? undefined : json['roles'],
        'photo': json['photo'] == null ? undefined : json['photo'],
        'description': json['description'] == null ? undefined : json['description'],
        'usersInHealthcareFacility': json['usersInHealthcareFacility'] == null ? undefined : ((json['usersInHealthcareFacility'] as Array<any>).map(GetUserInHealthcareFacilityDtoFromJSON)),
        'companiesInUser': json['companiesInUser'] == null ? undefined : ((json['companiesInUser'] as Array<any>).map(GetUserInCompanyDtoFromJSON)),
        'hasCertificate': json['hasCertificate'] == null ? undefined : json['hasCertificate'],
        'signP1WithSzafir': json['signP1WithSzafir'] == null ? undefined : json['signP1WithSzafir'],
        'twoFactorEnabled': json['twoFactorEnabled'] == null ? undefined : json['twoFactorEnabled'],
        'lastExamAt': json['lastExamAt'] == null ? undefined : (new Date(json['lastExamAt'])),
        'lastTfaActivityAt': json['lastTfaActivityAt'] == null ? undefined : (new Date(json['lastTfaActivityAt'])),
    };
}

export function GetUserDtoToJSON(value?: GetUserDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'name': value['name'],
        'email': value['email'],
        'licenseNumber': value['licenseNumber'],
        'pwz': value['pwz'],
        'occupationalMedicineDoctorIdentifier': value['occupationalMedicineDoctorIdentifier'],
        'uid': value['uid'],
        'pin': value['pin'],
        'admin': value['admin'],
        'superadmin': value['superadmin'],
        'emailWithReferral': value['emailWithReferral'],
        'active': value['active'],
        'roles': value['roles'],
        'photo': value['photo'],
        'description': value['description'],
        'usersInHealthcareFacility': value['usersInHealthcareFacility'] == null ? undefined : ((value['usersInHealthcareFacility'] as Array<any>).map(GetUserInHealthcareFacilityDtoToJSON)),
        'companiesInUser': value['companiesInUser'] == null ? undefined : ((value['companiesInUser'] as Array<any>).map(GetUserInCompanyDtoToJSON)),
        'hasCertificate': value['hasCertificate'],
        'signP1WithSzafir': value['signP1WithSzafir'],
        'twoFactorEnabled': value['twoFactorEnabled'],
        'lastExamAt': value['lastExamAt'] == null ? undefined : ((value['lastExamAt'] as any).toISOString()),
        'lastTfaActivityAt': value['lastTfaActivityAt'] == null ? undefined : ((value['lastTfaActivityAt'] as any).toISOString()),
    };
}

